export default function Wellness() {
  return (
    <section id="wellness" className="py-24 px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-6">
            <p className="text-sm tracking-widest text-gray-500 uppercase">心身の調律</p>
            <h3 className="text-4xl md:text-5xl font-serif text-gray-900 leading-tight">
              静寂に包まれ、自分を取り戻す
            </h3>
            <p className="text-gray-600 leading-relaxed text-base">
              1,500㎡に広がるスパフロア。日本古来の養生法と最新のトリートメントを融合させた施術で、心身の深い癒しをお届けいたします。
            </p>
            <p className="text-gray-600 leading-relaxed text-base">
              25mの温水プール、最新設備のフィットネス、8室の個室トリートメントルーム。都心にありながら、深い静寂に包まれた空間です。
            </p>
            <div className="grid grid-cols-3 gap-6 pt-6">
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center">
                  <i className="ri-water-flash-line text-3xl text-gray-900"></i>
                </div>
                <p className="text-sm text-gray-600">25mプール</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center">
                  <i className="ri-heart-pulse-line text-3xl text-gray-900"></i>
                </div>
                <p className="text-sm text-gray-600">スパトリートメント</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center">
                  <i className="ri-run-line text-3xl text-gray-900"></i>
                </div>
                <p className="text-sm text-gray-600">フィットネス</p>
              </div>
            </div>
            <button className="mt-6 px-8 py-3 border border-gray-900 text-gray-900 text-sm tracking-wide whitespace-nowrap hover:bg-gray-900 hover:text-white transition-all">
              スパを見る
            </button>
          </div>
          <div className="w-full h-[600px]">
            <img
              src="/demo/hotel-site/images/wellness.png"
              alt="Wellness Spa"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}